export const ProfileRouting = [
  {
    path: "/project/profile/list",
    name: "project-profile-list",
    meta: { title: "项目登记" },
    notice: { type: "project_examine", hasNotice: false },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/project/profile/list/index.vue"),
  },
  {
    hidden: true,
    path: "/project/profile/create",
    name: "project-profile-create",
    meta: { title: "新建项目", comName: "ProjectProfileFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/project/profile/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/profile/edit/:id",
    name: "project-profile-edit",
    meta: { title: "编辑项目", comName: "ProjectProfileFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/project/profile/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/profile/detail/:id",
    name: "project-profile-detail",
    meta: { title: "项目详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/project/profile/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/profile/project-view/:id",
    name: "project-profile-view",
    meta: { title: "项目详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/project/profile/project-view/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/profile/flowPrint/:id",
    name: "project-profile-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/project/profile/flow-print/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/general-add",
    name: "general-add",
    meta: { title: "通用新增" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/project/profile/project-view/general-add.vue"
      ),
  },
];
